import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ReplaySubject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CUSTOM_MASK } from '@helpers/custom-validator';
import { IErrorForm } from '@shared/form-wrapper/interfaces';

@Component({
  selector: 'app-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
})
export class PasswordInputComponent implements OnInit, OnDestroy {
  @Input() public fc: UntypedFormControl = new UntypedFormControl();
  @Input() public errors: IErrorForm;
  @Input() public label: string;
  @Input() public helper: string;
  @Input() public id: string = 'password';
  @Input() public maxLength: number;
  @Input() public isShowHelper: boolean = true;

  public isShowPassword: boolean = false;
  public CUSTOM_MASK: any = CUSTOM_MASK;

  private isDestroy: ReplaySubject<any> = new ReplaySubject();

  constructor() {}

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.isDestroy.next(true);
    this.isDestroy.complete();
  }

  public showPassword() {
    this.isShowPassword = true;
    timer(3000)
      .pipe(takeUntil(this.isDestroy))
      .subscribe(() => {
        this.isShowPassword = false;
      });
  }
}
